/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initRechargeFunctionality() {

    document.addEventListener('change', function(e) {
      const rcInfo = e.target.closest('.Product__RechargeInfo');
      if (rcInfo) {
        if (rcInfo.querySelector('[data-product-card-recharge]').checked) {
          rcInfo.classList.add('enabled');
        } else {
          rcInfo.classList.remove('enabled');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initRechargeFunctionality();
      initProductGridVariants();
    });
  } else {
    initRechargeFunctionality();
    initProductGridVariants();
  }

  function initProductGridVariants() {
    const productGrid = document.querySelector('main, .main-content, .collection-grid, .product-grid');
    
    if (productGrid && !productGrid.dataset.delegationInitialized) {
      const quickViewButtons = productGrid.querySelectorAll('[data-button-quick-view]');
      
      if (quickViewButtons.length === 0) {
        const observer = new MutationObserver(function(mutations) {
          const buttons = productGrid.querySelectorAll('[data-button-quick-view]');
          if (buttons.length > 0) {
            observer.disconnect();
            initProductGridVariants();
          }
        });
        
        observer.observe(productGrid, { childList: true, subtree: true });
        return;
      }
      
      productGrid.dataset.delegationInitialized = "true";

      quickViewButtons.forEach(button => {
        const variantsContainer = button.nextElementSibling;
        if (variantsContainer && variantsContainer.classList.contains('product-options__variants')) {
          const variantOptions = variantsContainer.querySelectorAll('.product-item-variants li[data-variant-id]');
          if (variantOptions.length === 1) {
            variantsContainer.style.display = 'none';
          }
        }
      });
    
      productGrid.addEventListener('mouseover', function(e) {
        const quickViewButton = e.target.closest('[data-button-quick-view]');
        
        if (quickViewButton) {
          const variantsContainer = quickViewButton.nextElementSibling;
          const variantOptions = variantsContainer ? 
            variantsContainer.querySelectorAll('.product-item-variants li[data-variant-id]') : [];
          
         
          if (variantOptions.length > 1 && variantsContainer) {
          
            variantsContainer.style.display = 'block';
            variantsContainer.style.visibility = 'visible';
            variantsContainer.style.opacity = '1';
            variantsContainer.style.pointerEvents = 'auto';
          }
        }
        
        const variantOption = e.target.closest('.product-item-variants li[data-variant-id]');
        
        if (variantOption) {
          variantOption.style.cursor = 'pointer';
          variantOption.classList.add('variant-hover');
        }
      }, true);
      
      productGrid.addEventListener('mouseout', function(e) {
        const quickViewButton = e.target.closest('[data-button-quick-view]');
        
        if (quickViewButton) {
          const variantsContainer = quickViewButton.nextElementSibling;
          
          if (variantsContainer) {
        
            const relatedTarget = e.relatedTarget;
            const isGoingToContainer = relatedTarget && variantsContainer.contains(relatedTarget);
            
            if (!isGoingToContainer) {
     
              variantsContainer.style.display = 'none';
            }
          }
        }
        
        const variantOption = e.target.closest('.product-item-variants li[data-variant-id]');
        
        if (variantOption) {
          variantOption.style.cursor = 'default';
          variantOption.classList.remove('variant-hover');
        }
      }, true);
      
      document.querySelectorAll('.product-options__variants').forEach(container => {
        container.addEventListener('mouseenter', function() {
          this.style.display = 'block';
          this.style.visibility = 'visible';
          this.style.opacity = '1';
        });
        
        container.addEventListener('mouseleave', function() {
          const quickViewButton = this.previousElementSibling;
          if (quickViewButton && !quickViewButton.matches(':hover')) {
            this.style.display = 'none';
          }
        });
      });
    
      productGrid.addEventListener('click', function(e) {
        const quickViewButton = e.target.closest('[data-button-quick-view]');
        
        // Handle quick view button click
        if (quickViewButton) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const variantsContainer = quickViewButton.nextElementSibling;
          const variantOptions = variantsContainer ? 
            variantsContainer.querySelectorAll('.product-item-variants li[data-variant-id]') : [];
          
          if (variantOptions.length > 0) {
            const FIRST_VARIANT_INDEX = 0;
            const DEFAULT_QUANTITY = 1;
            const targetVariant = variantOptions[FIRST_VARIANT_INDEX];
            const variantId = targetVariant.getAttribute('data-variant-id');
            
            showAddingFeedback(quickViewButton);
            addVariantToCart(variantId, DEFAULT_QUANTITY, quickViewButton);
          }
          
          return false;
        }
        
        const variantOption = e.target.closest('.product-item-variants li[data-variant-id]');
        
        if (variantOption) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const variantId = variantOption.getAttribute('data-variant-id');
          
          addVariantToCart(variantId, 1, variantOption);
          
          return false;
        }
      }, true);
      
      productGrid.addEventListener('touchend', function(e) {
        const quickViewButton = e.target.closest('[data-button-quick-view]');
        
        if (quickViewButton) {
          const variantsContainer = quickViewButton.nextElementSibling;
          const variantOptions = variantsContainer ? 
            variantsContainer.querySelectorAll('.product-item-variants li[data-variant-id]') : [];
          
          if (variantOptions.length === 1) {
            e.preventDefault();
            e.stopPropagation();
            
            const singleVariant = variantOptions[0];
            const variantId = singleVariant.getAttribute('data-variant-id');
            
            showAddingFeedback(quickViewButton);
            addVariantToCart(variantId, 1, quickViewButton);
          }
          else if (variantOptions.length > 1 && variantsContainer) {
            e.preventDefault();
            e.stopPropagation();
            
            const isVisible = variantsContainer.style.display === 'block';
            variantsContainer.style.display = isVisible ? 'none' : 'block';
          }
        }
      }, { passive: false });
      
      document.addEventListener('touchend', function(e) {
        const quickViewButton = e.target.closest('[data-button-quick-view]');
        const variantsContainer = e.target.closest('.product-options__variants');
        
        if (!quickViewButton && !variantsContainer) {
          const allVariantsContainers = document.querySelectorAll('.product-options__variants');
          allVariantsContainers.forEach(container => {
            container.style.display = 'none';
          });
        }
      }, { passive: false });
    }
  }

  const pendingRequests = new Set();

  function addVariantToCart(variantId, quantity, element) {
    const variantKey = String(variantId);
    
    if (pendingRequests.has(variantKey)) {
      return;
    }
    pendingRequests.add(variantKey);

    let eventHandled = false;
    
    const container = element.closest('.product-options__variants');
    const mainButton = container ? container.previousElementSibling : null;
    
    if (mainButton) {
      showAddingFeedback(mainButton);
      mainButton.classList.add('loading');
      mainButton.style.opacity = '0.6';
    }
    
   
    const productGridItem = element.closest('.product-grid-item');
    let sellingPlan = null;
    
    if (productGridItem) {
      const rcInfo = productGridItem.querySelector('.Product__RechargeInfo.enabled');
      if (rcInfo) {
        const rcOptEl = rcInfo.querySelector('select');
        if (rcOptEl) {
          sellingPlan = rcOptEl.value;
        }
      }
    }
    
    const cartData = {
      items: [{
        id: parseInt(variantId),
        quantity: parseInt(quantity)
      }]
    };

    if (sellingPlan) {
      cartData.items[0].selling_plan = sellingPlan;
    }
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      if (eventHandled) return;
      
      if (data.status && data.status >= 400) {
        throw new Error(data.description || data.message || 'Shopify API error');
      }
      
      if (data.errors || data.error) {
        const errorMessage = data.errors || data.error || 'Unknown Shopify error';
        throw new Error(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
      }
      
      eventHandled = true;
      
      try {
        if (mainButton) {
          showSuccessFeedback(mainButton);
        } else if (element.matches('[data-button-quick-view]')) {
          showSuccessFeedback(element);
        }
        
        if (container) {
          container.style.display = 'none';
        }
        
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        
        document.dispatchEvent(new CustomEvent('theme:cart:added', { 
          bubbles: true,
          detail: data
        }));
        
      } catch (error) {
        console.error('Error in success handler:', error);
      }
    })
    .catch(error => {
      if (eventHandled) return;
      eventHandled = true;
      
      try {
        if (mainButton) {
          showErrorFeedback(mainButton);
        } else if (element.matches('[data-button-quick-view]')) {
          showErrorFeedback(element);
        }
        
        console.error('Error adding to cart:', error);
      } catch (handlerError) {
        console.error('Error in error handler:', handlerError);
      }
    })
    .finally(() => {
      pendingRequests.delete(variantKey);
    });
    
    setTimeout(() => {
      if (!eventHandled) {
        eventHandled = true;
        pendingRequests.delete(variantKey);
      }
    }, 5000);
  }

  function showSuccessFeedback(element) {
    const isMainButton = element.matches('[data-button-quick-view]') || element.closest('[data-button-quick-view]');
    
    if (isMainButton) {
      const btnText = element.querySelector('.btn__text');
      
      if (btnText) {
        btnText.textContent = 'ADDED!';
      }
      
      setTimeout(() => {
        resetButton(element);
      }, 1500);
    } else {
      const originalText = element.textContent;
      element.textContent = 'ADDED!';
      element.classList.add('success-feedback');
      
      setTimeout(() => {
        element.textContent = originalText;
        element.classList.remove('success-feedback');
      }, 1500);
    }
  }

  function showAddingFeedback(button) {
    const btnText = button.querySelector('.btn__text');
    if (btnText) {
      if (!button.hasAttribute('data-original-text')) {
        button.setAttribute('data-original-text', btnText.textContent);
      }
      btnText.textContent = 'ADDING...';
    }
  }

  function resetButton(button) {
    const btnText = button.querySelector('.btn__text');
    if (btnText) {
      const originalText = button.getAttribute('data-original-text') || 'Quick View';
      btnText.textContent = originalText;
    }
    button.classList.remove('loading');
    button.style.opacity = '';
    button.removeAttribute('data-original-text');
  }

  function showErrorFeedback(element) {
    const isMainButton = element.matches('[data-button-quick-view]') || element.closest('[data-button-quick-view]');
    
    if (isMainButton) {
      const btnText = element.querySelector('.btn__text');
      
      if (btnText) {
        btnText.textContent = 'ERROR';
      }
      
      setTimeout(() => {
        resetButton(element);
      }, 1500);
    } else {
      const originalText = element.textContent;
      element.textContent = 'ERROR';
      element.classList.add('error-feedback');
      
      setTimeout(() => {
        element.textContent = originalText;
        element.classList.remove('error-feedback');
      }, 1500);
    }
  }

  // Initialize recharge functionality
  initRechargeFunctionality();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
